import React from 'react';
import AttachmentCardComponent, { type AttachmentRow } from './AttachmentCard';
import type { ContextItem } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

type AssetAttachment = {
  id?: string;
  resourceType?: string;
  region?: string;
  name?: string;
  packages?: Record<
    string,
    ReadonlyArray<string> | ReadonlyArray<{ name: string }>
  >;
};

export const AssetContext: React.FC<{
  item: ContextItem;
  onRemove: () => void;
}> = ({ item, onRemove }) => {
  const { t } = useTranslation('pleri/chat');
  const asset = item.attachmentMetaData as AssetAttachment | undefined;

  const rows: Array<AttachmentRow> = [];
  if (asset?.resourceType) {
    rows.push({ label: t('resource'), value: asset.resourceType });
  }
  if (asset?.region) {
    rows.push({ label: t('region'), value: asset.region });
  }
  if (asset?.packages) {
    const packageGroups = Object.values(asset.packages);
    let packagesCount = 0;
    for (const group of packageGroups) {
      packagesCount += Array.isArray(group) ? group.length : 0;
    }
    if (packagesCount > 0) {
      rows.push({ label: t('packages'), value: `${packagesCount} affected` });
    }
  }

  return (
    <AttachmentCardComponent
      icon={item.icon}
      title={asset?.name || asset?.id || t('asset')}
      rows={
        rows.length
          ? rows
          : item.display
            ? [{ label: t('asset'), value: String(item.display) }]
            : []
      }
      onRemove={onRemove}
      removeAriaLabel="Remove asset context"
    />
  );
};

export default AssetContext;
